
import { Component, Vue, Watch } from "vue-property-decorator";
import { announcementsModule } from "@/store/modules/store-accessor";
import { announcementColor, announcementIcon } from "@/helpers/data";

@Component
export default class AnnouncementsStack extends Vue {
    async mounted() {
        await announcementsModule.getAllAnnouncements();
    }

    get announcements() {
        return announcementsModule.announcements;
    }

    async dismissAnnouncement(announcementId: string) {
        await announcementsModule.createAnnouncementException(announcementId);
    }

    announcementColor(type: string) {
        return announcementColor(type)
    }

    announcementIcon(type: string) {
        return announcementIcon(type)
    }

    announcementHtml(announcement: any) {
        return `<strong>${announcement.title}</strong><br />${announcement.message}`;
    }

    // We need this watch in order to fetch the new announcements when we visit other pages
    // Without we would have to do a real browswer refresh
    @Watch('$route')
    async onRouteChange() {
        await announcementsModule.getAllAnnouncements();
    }

}
